import { Department, IUser } from '../../../entities/User'

export const mapCSuite = (user: IUser) => {
    // @ts-expect-error
    if (user.departmentName === 'cSuite') {
        user.departmentName = Department.C_SUITE
    }
    return user
}
